import { Button } from 'components'
import { STATICS } from 'statics'
import './style.scss'

export function ConfirmScheduleError({ onClose }) {
  return (
    <div className='confirm-schedule-error'>
      <div className='icon-container'>
        <div className='icon'>
          <STATICS.INFO_CIRCLE />
        </div>
      </div>
      <div className='content'>
        <h3 className='content-header'>Não foi possível concluir a sua solicitação</h3>
        <p>
          Tente novamente em alguns minutos ou entre em contato com a nossa Central de Atendimento
        </p>
      </div>
      <div className='actions'>
        <Button onClick={onClose} color='primary'>
          Ok, entendi!
        </Button>
      </div>
    </div>
  )
}
